import { useMemo } from 'react';

import {
  initMixpanel,
  identifyUser,
  trackEvent,
  timeEvent,
  setUserProperties,
  optOut,
  optIn,
  resetUser,
} from '@setup/config/mixpanel';

export const useMixpanelAnalytics = () => {
  return useMemo(
    () => ({
      initMixpanel,
      identifyUser,
      trackEvent,
      timeEvent,
      setUserProperties,
      optOut,
      optIn,
      resetUser,
    }),
    [],
  );
};
